import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal, SectionHeading, EASE } from "@/components/Reveal";

const FOUNDER_IMG = "/images/founder.jpg";

export default function ChiSiamo() {
  return (
    <section id="chi-siamo" className="relative py-24 sm:py-32 bg-surface/40">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <SectionHeading
          overline="Chi sono"
          title={<>Giango, il primo studio di creatività applicata.</>}
          testId="chisiamo-title"
        />

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            data-testid="chisiamo-image"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1, ease: EASE }}
            className="lg:col-span-5 relative"
          >
            <div className="relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/5] max-w-md mx-auto lg:ml-0">
              <img
                src={FOUNDER_IMG}
                alt="Giango — creatività applicata"
                loading="lazy"
                className="h-full w-full object-cover img-duotone"
              />
              <div
                className="absolute inset-0 bg-gradient-to-t from-obsidian/80 via-transparent to-transparent"
                aria-hidden="true"
              />
              <div className="absolute bottom-5 left-5 right-5">
                <p className="font-display font-bold text-xl text-ink" data-testid="chisiamo-founder-name">
                  Giango
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ember mt-1">
                  Creatività applicata — Fondatore
                </p>
              </div>
            </div>
            <span
              className="absolute -top-3 -right-3 sm:-right-5 h-16 w-16 border-t-2 border-r-2 border-ember rounded-tr-2xl"
              aria-hidden="true"
            />
          </motion.div>

          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-lg sm:text-xl text-zinc-300 leading-relaxed">
                Giango è il primo studio di creatività applicata: soluzioni
                creative, mirate ed efficaci per rispondere alle esigenze dei
                clienti, nel mondo della comunicazione come in quello della
                formazione.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed max-w-2xl">
                Niente idee astratte: ogni progetto parte dalle esigenze
                concrete dell'azienda e diventa uno strumento che funziona.
                Dalla comunicazione interna agli eventi, dal team building ai
                video — tradizionali o con l'intelligenza artificiale.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="mt-10 flex items-start gap-4 rounded-xl border border-ember/30 bg-ember/5 p-6 max-w-2xl">
                <Quote className="h-6 w-6 text-ember shrink-0 mt-1" aria-hidden="true" />
                <div>
                  <p className="font-display font-bold text-xl sm:text-2xl text-ink italic">
                    «Accetto la sfida.»
                  </p>
                  <p className="mt-2 text-sm text-zinc-400">
                    Il motto con cui affronto ogni brief, dai più semplici
                    ai più complessi.
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
